export namespace IParkChoice {
    export const ACTION = 'ParkChoice_MK';

    export enum Commands {
        PARKS_MY_PRIVAT = 'parksMyPrivat',
        LIST_CORPS = 'ListCorps',
        CORP_ADD = 'CorpAdd',
        CORP_DEL = 'CorpDel',
    }
}
